import type { FC } from 'react'
import React from 'react'
import { v4 as uuid } from 'uuid'
import SimpleGrid from '@vfuk/core-simple-grid'
import Heading from '@vfuk/core-heading'
import Link from '@vfuk/core-link'
import ListGroup from '@vfuk/core-list-group'
import ListItem from '@vfuk/core-list-item'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/DesktopLinkList.style'

import type { DesktopLinkListProps } from './DesktopLinkList.types'

const DesktopLinkList: FC<DesktopLinkListProps> = ({ linkGroups, onInteractionClick, inverse, dataSelectorPrefix }) => {
  const getNumberOfColumns = (): 2 | 3 | 4 => {
    const groupsLength = linkGroups!.groups.length

    if (groupsLength === 3 || groupsLength === 5 || groupsLength === 6) {
      return 3
    }

    if (groupsLength === 4 || groupsLength === 7 || groupsLength === 8) {
      return 4
    }

    return 2
  }

  return (
    <SimpleGrid
      columns={{
        lg: getNumberOfColumns(),
      }}
      spacing={4}
      dataSelectorPrefix={getDataSelector(dataSelectorPrefix)}
    >
      {linkGroups!.groups.map((group, index) => (
        <Styled.DesktopLinkListWrapper key={uuid()}>
          <Heading size={1} weight={3} inverse={inverse} dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `group-heading-${index}`)}>
            {group.headingText}
          </Heading>
          <ListGroup dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `group-list-${index}`)}>
            {group.links.map((link) => (
              <ListItem key={link.id} dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `group-list-item-${index}`)}>
                <Link
                  inverse={inverse}
                  srText={link.srText}
                  href={link.href}
                  customRouterProps={link.customRouterProps}
                  onClick={onInteractionClick}
                  dataSelectorPrefix={getDataSelector(dataSelectorPrefix, `group-list-item-link-${index}`)}
                  {...link.dataAttributes}
                >
                  {link.text}
                </Link>
              </ListItem>
            ))}
          </ListGroup>
        </Styled.DesktopLinkListWrapper>
      ))}
    </SimpleGrid>
  )
}

export default DesktopLinkList
